/**
 * NanoCMD/NanoHub API Service (Frontend)
 *
 * Ruft die Xavier-Backend-API auf, die ihrerseits NanoCMD/NanoHub anspricht.
 */

import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_SERVER}/api/nanocmd`;

const authHeaders = () => {
  const tokenStr = localStorage.getItem('user');
  if (!tokenStr) return {};
  try {
    const token = JSON.parse(tokenStr).token;
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
};

/**
 * Prüft ob NanoCMD verfügbar ist
 */
export async function getNanoCmdStatus() {
  const { data } = await axios.get(`${API_URL}/status`, { headers: authHeaders() });
  return data;
}

/**
 * Holt die Profile aus dem NanoCMD Profile Subsystem
 */
export async function getNanoCmdProfiles() {
  const { data } = await axios.get(`${API_URL}/profiles`, { headers: authHeaders() });
  return data.profiles || [];
}

/**
 * Holt den Profil-Inhalt (Base64) aus NanoCMD
 */
export async function getNanoCmdProfileContent(name) {
  const { data } = await axios.get(`${API_URL}/profile/${encodeURIComponent(name)}/content`, { headers: authHeaders() });
  return data.content;
}

/**
 * Aktualisiert ein Profil in NanoCMD (Body: { content: base64 })
 */
export async function updateNanoCmdProfile(name, content) {
  const { data } = await axios.put(
    `${API_URL}/profile/${encodeURIComponent(name)}`,
    { content },
    { headers: { ...authHeaders(), 'Content-Type': 'application/json' } }
  );
  return data;
}

/**
 * Holt die konfigurierten Command Plans
 */
export async function getNanoCmdCmdPlans() {
  const { data } = await axios.get(`${API_URL}/cmdplans`, { headers: authHeaders() });
  return data.cmdplans || [];
}

/**
 * Holt einen einzelnen Command Plan
 */
export async function getNanoCmdCmdPlan(name) {
  const { data } = await axios.get(`${API_URL}/cmdplan/${encodeURIComponent(name)}`, { headers: authHeaders() });
  return data;
}

/**
 * Startet den Command-Plan-Workflow für ein Gerät
 */
export async function startNanoCmdCmdPlanWorkflow(udid, cmdPlanName) {
  const { data } = await axios.post(
    `${API_URL}/workflow/cmdplan/start`,
    { udid, cmdPlanName },
    { headers: { ...authHeaders(), 'Content-Type': 'application/json' } }
  );
  return data;
}

/**
 * Startet den Profile-Workflow für ein Gerät
 */
export async function startNanoCmdProfileWorkflow(udid, profileNames) {
  const { data } = await axios.post(
    `${API_URL}/workflow/profile/start`,
    { udid, profileNames },
    { headers: { ...authHeaders(), 'Content-Type': 'application/json' } }
  );
  return data;
}

/** Default-Export für einfachen Zugriff */
const nanoCmdService = {
  getStatus: getNanoCmdStatus,
  getProfiles: async () => {
    const profiles = await getNanoCmdProfiles();
    return { profiles };
  },
  getNanoCmdProfileContent,
  updateNanoCmdProfile,
  getCmdPlans: getNanoCmdCmdPlans,
  getCmdPlan: getNanoCmdCmdPlan,
  startCmdPlanWorkflow: startNanoCmdCmdPlanWorkflow,
  startProfileWorkflow: startNanoCmdProfileWorkflow,
};
export default nanoCmdService;
